"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReporterSymbol = void 0;
exports.ReporterSymbol = Symbol('ReporterSite');
//# sourceMappingURL=reporter.js.map